import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-gradient-to-br from-[#F2D70A] to-[#544E13] rounded-lg flex items-center justify-center">
              <i className="ri-fire-line text-2xl text-white"></i>
            </div>
            <span className="text-2xl font-bold text-[#544E13]">RESTAURAX</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isActive('/') ? 'text-[#F2D70A]' : 'text-gray-700 hover:text-[#F2D70A]'
              }`}
            >
              Inicio
            </Link>
            <Link 
              to="/empresa" 
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isActive('/empresa') ? 'text-[#F2D70A]' : 'text-gray-700 hover:text-[#F2D70A]'
              }`}
            >
              Empresa
            </Link>
            <Link 
              to="/servicios" 
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isActive('/servicios') ? 'text-[#F2D70A]' : 'text-gray-700 hover:text-[#F2D70A]'
              }`}
            >
              Servicios
            </Link>
            <Link 
              to="/faq" 
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isActive('/faq') ? 'text-[#F2D70A]' : 'text-gray-700 hover:text-[#F2D70A]'
              }`}
            >
              FAQ
            </Link>
            <Link 
              to="/contacto" 
              className="bg-[#F2D70A] text-[#544E13] px-6 py-2.5 rounded-lg font-semibold hover:bg-[#544E13] hover:text-white transition-all whitespace-nowrap"
            >
              Contacto
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-[#F2D70A] cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/" 
                onClick={() => setIsMenuOpen(false)}
                className={`text-base font-medium transition-colors ${
                  isActive('/') ? 'text-[#F2D70A]' : 'text-gray-700'
                }`}
              >
                Inicio
              </Link>
              <Link 
                to="/empresa" 
                onClick={() => setIsMenuOpen(false)}
                className={`text-base font-medium transition-colors ${
                  isActive('/empresa') ? 'text-[#F2D70A]' : 'text-gray-700'
                }`}
              >
                Empresa
              </Link>
              <Link 
                to="/servicios" 
                onClick={() => setIsMenuOpen(false)}
                className={`text-base font-medium transition-colors ${
                  isActive('/servicios') ? 'text-[#F2D70A]' : 'text-gray-700'
                }`}
              >
                Servicios
              </Link>
              <Link 
                to="/faq" 
                onClick={() => setIsMenuOpen(false)}
                className={`text-base font-medium transition-colors ${
                  isActive('/faq') ? 'text-[#F2D70A]' : 'text-gray-700'
                }`}
              >
                FAQ
              </Link>
              <Link 
                to="/contacto" 
                onClick={() => setIsMenuOpen(false)}
                className="bg-[#F2D70A] text-[#544E13] px-6 py-2.5 rounded-lg font-semibold text-center whitespace-nowrap"
              >
                Contacto
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}